export default __webpack_public_path__ + "static/media/DNo.14-3.d942d941.jpg";